import React, {useEffect, useState} from "react";
import {useAuth} from "../../authprovider";
import Navigationbar from "../Navigationbar";
import UsersCard from "../building/UsersComponent";

export default function UsersPage(props){

    const {buildings, user} = useAuth();
    const [building, setBuilding] = useState(undefined)

    useEffect(()=>{
        if(building === undefined && user.hasBuilding){
            buildings.getBuilding(user.building, response=>{
                const {success, error, content} = response;

                if(success === true){
                    setBuilding(content)
                } else
                    console.log(error)
            })
        }
    })

    if(!building) return <></>


    return (
        <>
            <Navigationbar/>
            <div className={"container"}>
                <UsersCard data-building={building} />
            </div>

        </>

    )
}